import { HidableAvatarView } from "@/modules/common/entities/person/person-avatar";
import { ToEmployeeProfileLink } from "@/modules/profile/pages/employee-profile";
import { PersonName } from "@/modules/common/entities/person/person-name";
import { PersonNameColumnFragment } from "gql/graphql";
import { ReactNode } from "react";

export type PersonNameColumnViewProps = {
  data: PersonNameColumnFragment;
  afterName?: ReactNode;
  extra?: ReactNode;
};

export function PersonNameColumnView({
  data,
  afterName,
  extra,
}: PersonNameColumnViewProps) {
  return (
    <div className="grid grid-cols-[min-content_1fr] items-center gap-x-2">
      <div>
        <ToEmployeeProfileLink id={data.id}>
          <HidableAvatarView data={data.avatar} size="large" />
        </ToEmployeeProfileLink>
      </div>

      <div>
        <div className={"flex items-center gap-x-2"}>
          <ToEmployeeProfileLink id={data.id}>
            <PersonName data={data} />
          </ToEmployeeProfileLink>

          {afterName}
        </div>

        {extra}
      </div>
    </div>
  );
}
